import { instance as axiosInstance } from '../axiosInstance';

const headersFor = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export const getGarantias = (token) =>
  axiosInstance.get('/api/administrador/garantias', { headers: headersFor(token) });

export const updateGarantias = (token, payload) =>
  axiosInstance.put('/api/administrador/garantias', payload, { headers: headersFor(token) });

export const getGarantiasOpcoes = (token) =>
  axiosInstance.get('/api/administrador/garantias/opcoes', {
    headers: headersFor(token),
  });
